angular.module('hcap-analytics').controller('InvitesCtrl', [
  '$scope',
  '$state',
  'InvitesService',
function(
  $scope,
  $state,
  InvitesService,
) {
  $scope.taggedAssessments = [];
  $scope.unfinishedPhases = [];
  $scope.csmCohortInvites = [];
  $scope.isCsmPortal = $state.params.portal === 'CSM';
  $scope.startCase = _.startCase;

  $scope.$watch(() => InvitesService.noticeCount, newVal => {
    $scope.taggedAssessments = InvitesService.taggedAssessments;
    $scope.unfinishedPhases = InvitesService.unfinishedPhases;
    $scope.csmCohortInvites = InvitesService.csmCohortInvites;
  });

  $scope.goInvite = assessment => {
    if (assessment.inviteType === 'bundle') {
      $state.go('rate-bundle', {
        portal: 'CSM',
        participantId: assessment.bundleParticipantId,
      });
      return;
    }

    $state.go('participate.questions', {
      templateId: assessment.template_guid,
      participantId: assessment.participant.guid,
      finishRoute: 'participate.rater-finish',
      onFinish: InvitesService.update,
      asRater: true,
    });
  };

  $scope.goPhase = phase => {
    $state.go('team', {
      id: phase.cohortId,
      phase: phase.phaseIndex,
    });
  };
}]);
